import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/dist/', //添加的地方
  base: '/', //添加的地方
  routes: [
    {
      path: '/',
      name: 'schoolpage',
      component: resolve => require(['@/skinschool/schoolpage.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//医美学堂主页
    {
      path: '/classsearch',
      name: 'classsearch',
      component: resolve => require(['@/class/classsearch.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//医美学堂小课堂搜索
    {
      path: '/smallclassroom',
      name: 'smallclassroom',
      component: resolve => require(['@/class/smallclassroom.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//医美学堂小课堂
    {
      path: '/classlist',
      name: 'classlist',
      component: resolve => require(['@/class/classlist.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//课堂列表
    {
      path: '/teacherhomepage',
      name: 'teacherhomepage',
      component: resolve => require(['@/class/teacherhomepage.vue'], resolve),
    },//名医主页
    {
      path: '/teacherlist',
      name: 'teacherlist',
      component: resolve => require(['@/class/teacherlist.vue'], resolve),
    },//课堂名医列表
    {
      path: '/doctorlist',
      name: 'doctorlist',
      component: resolve => require(['@/advice/doctorlist.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//医生列表
    {
      path: '/advicemenu',
      name: 'advicemenu',
      component: resolve => require(['@/advice/advicemenu.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//问壹声资讯列表
    {
      path: '/schoolcomment',
      name: 'schoolcomment',
      component: resolve => require(['@/skinschool/schoolcomment.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//医美学堂评论页
    {
      // mode: 'history',
      path: '/schooldetail',
      name: 'schooldetail',
      component: resolve => require(['@/skinschool/schooldetail.vue'], resolve)
    },//医美学堂详情
    {
      path: '/followlist',
      name: 'followlist',
      component: resolve => require(['@/advice/followlist.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//关注列表
    {
      path: '/articlelist',
      name: 'articlelist',
      component: resolve => require(['@/advice/articlelist.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//
    {
      path: '/pay',
      name: 'pay',
      component: resolve => require(['@/advice/pay.vue'], resolve),
    },//支付
    {
      path: '/beautyitem/:id',
      name: 'beautyitem',
      component: resolve => require(['@/skin/beautyitem.vue'], resolve),
    },//求美记皮肤档案
    {
      path: '/beautylist',
      name: 'beautylist',
      component: resolve => require(['@/advice/beautylist.vue'], resolve),
    },
    {
        path: '/skinarchives',
      name: 'skinarchives',
      component: resolve => require(['@/skin/skinarchives.vue'], resolve),
    },//皮肤档案
    {
      path: '/articlecomment',
      name: 'articlecomment',
      component: resolve => require(['@/advice/articlecomment.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//医生咨询评价
    {
      path: '/doctorpage',
      name: 'doctorpage',
      component: resolve => require(['@/advice/doctorpage.vue'], resolve)
    },//医生首页
    {
      path: '/addcomment',
      name: 'addcomment',
      component: resolve => require(['@/advice/addcomment.vue'], resolve),
    },//添加评论
    {
      path: '/adviceexplain',
      name: 'adviceexplain',
      component: resolve => require(['@/advice/adviceexplain.vue'], resolve),
    },//去咨询
    {
      path: '/consulting',
      name: 'consulting',
      component: resolve => require(['@/advice/consulting.vue'], resolve),
    },//去咨询
    {
      path: '/advicelist',
      name: 'advicelist',
      component: resolve => require(['@/advice/advicelist.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//
    // {
    //   path: '/advicelist2',
    //   name: 'advicelist2',
    //   component: resolve => require(['@/advice/advicelist2.vue'], resolve),
    //   meta:{
    //     keepAlive:true //需要被缓存的组件
    //   }
    // },//
    {
      path: '/selectcase',
      name: 'selectcase',
      component: resolve => require(['@/advice/selectcase.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//支付后选怎评价
    {
      path: '/videolist',
      name: 'videolist',
      component: resolve => require(['@/video/videolist.vue'], resolve),
      meta:{
        keepAlive:true //需要被缓存的组件
      }
    },//视频列表
    {
      path: '/videodetails',
      name: 'videodetails',
      component: resolve => require(['@/video/videodetails.vue'], resolve),
      meta:{
        keepAlive:false //需要被缓存的组件
      }
    }//视频详情页
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js